import React, {useState, useEffect} from "react";
import "./Album0.css";
import img001 from "../Games/Puzzle/001.png";
import img002 from "../Games/Puzzle/002.png";
import img003 from "../Games/Puzzle/003.png";
import img004 from "../Games/Puzzle/004.png";
import img005 from "../Games/Puzzle/005.png";

export default  function AlbumS0() {
    const [English, setEnglish] = useState(true);
    
    const ChangeToChinese =()=>{
        setEnglish(false);
    }

    const ChangeToEnglish =()=>{
        setEnglish(true);
    }

    useEffect(()=>{
        document.getElementById("radio1").checked=true;
    },[])

    return(
        <div>
        {English?(    
            <>
            <div className="AlbumS1">
                <h1> Album Style0</h1>
                <div className="AlbumS1-Language" onClick={ChangeToChinese}> <h3>中文</h3></div>

                <div  className="slider">
                    <div className="slides">
                        <input type="radio" name="radio-btn" id="radio1"/>
                        <input type="radio" name="radio-btn" id="radio2"/>
                        <input type="radio" name="radio-btn" id="radio3"/>
                        <input type="radio" name="radio-btn" id="radio4"/>
                        <input type="radio" name="radio-btn" id="radio5"/>

                        <div className="slide first">
                            <img src={img001} alt=""/>
                        </div>
                        <div className="slide">
                            <img src={img002} alt=""/>
                        </div>
                        <div className="slide ">
                            <img src={img003} alt=""/>
                        </div>
                        <div className="slide ">
                            <img src={img004} alt=""/>
                        </div>
                        <div className="slide ">
                            <img src={img005} alt=""/>
                        </div>

                        <div className="navigation-auto">
                            <div className="auto-btn1"></div>
                            <div className="auto-btn2"></div>
                            <div className="auto-btn3"></div>
                            <div className="auto-btn4"></div>
                            <div className="auto-btn5"></div>
                        </div> 
                    </div>

                    <div className="navigation-manual">
                        <label for="radio1" className="manual-btn"></label>
                        <label for="radio2" className="manual-btn"></label>
                        <label for="radio3" className="manual-btn"></label>
                        <label for="radio4" className="manual-btn"></label>
                        <label for="radio5" className="manual-btn"></label>
                    </div>
                </div>

            </div>
            </>
        ):(
            <>
            <div className="AlbumS1">
                <h1> 相册 样式0</h1>
                <div className="AlbumS1-Language" onClick={ChangeToEnglish}> <h3>English</h3></div>
                
                <div  className="slider">
                    <div className="slides">
                        <input type="radio" name="radio-btn" id="radio1"/>
                        <input type="radio" name="radio-btn" id="radio2"/>
                        <input type="radio" name="radio-btn" id="radio3"/>
                        <input type="radio" name="radio-btn" id="radio4"/>
                        <input type="radio" name="radio-btn" id="radio5"/>

                        <div className="slide first">
                            <img src={img001} alt=""/>
                        </div>
                        <div className="slide">
                            <img src={img002} alt=""/>
                        </div>
                        <div className="slide ">
                            <img src={img003} alt=""/>
                        </div>
                        <div className="slide ">
                            <img src={img004} alt=""/>
                        </div>
                        <div className="slide ">
                            <img src={img005} alt=""/>
                        </div>

                        <div className="navigation-auto">
                            <div className="auto-btn1"></div>
                            <div className="auto-btn2"></div>
                            <div className="auto-btn3"></div>
                            <div className="auto-btn4"></div>
                            <div className="auto-btn5"></div>
                        </div> 
                    </div>

                    <div className="navigation-manual">
                        <label for="radio1" className="manual-btn"></label>
                        <label for="radio2" className="manual-btn"></label>
                        <label for="radio3" className="manual-btn"></label>
                        <label for="radio4" className="manual-btn"></label>
                        <label for="radio5" className="manual-btn"></label>
                    </div>
                </div>
            </div>
            </>
        )}
        </div>
    )
}